import { Action } from '../../common/actions/core/action';

export class PaycellInfoDialogAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/buy/paycell-info-dialog/paycell-info-dialog.action.ts